import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PrivacyPolicy.css'; // Import your CSS

const PrivacyPolicy = () => {
  return (
    <section className="privacy-section">
    <div className="privacy-policy-container">
      <h1 className="privacy-title">Privacy</h1>
      <p className="privacy-updated">Updated: {new Date().toDateString()}</p>

      <div className="privacy-content">
        <p>
          At Growth Labs, your privacy is our priority. This Privacy Policy outlines how we collect, use,
          and protect your information when you visit our website, use our services, or interact with us
          online. By using our website or services, you consent to the practices described in this Privacy Policy.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>Personal Information: Name, email address, phone number, and other details you provide through forms or communications.</li>
          <li>Usage Data: Information about how you interact with our website, such as IP address, browser type, operation system, pages visited, and time spent on the site.</li>
          <li>Cookies and Tracking Technologies: Information collected through cookies, pixels, and similar tools to enhance user experience and analyze site performance.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Growth Labs uses the information we collect to:</p>
        <ul>
          <li>Provide and improve our services.</li>
          <li>Respond to your inquiries and requests.</li>
          <li>Personalize your user experience and tailor marketing efforts.</li>
          <li>Analyze website performance and user behavior.</li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>We do not sell or rent your personal information. However, we may share your data with trusted third parties to:</p>
        <ul>
            <li>Facilitate service delivery (e.g. payment processors or hosting providers).</li>
            <li>Comply with legal obligations or respond to lawful requests.</li>
            <li>Protect the rights, safets, or property of Growth Labs, our users, or others.</li>
        </ul>

        <h2>4. Data Retention</h2>
        <p>We retain your information only as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.</p>

        <h2>5. Security Measures</h2>
        <p>We implement industry-standard measures to protect your information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

        <h2>6. Your Choices</h2>
        <ul>
            <li>Opt-Out: You can opt-out of receiving prootional emails by following the unsubscribe link in our communications.</li>
            <li>Cookie Preferences: Manage or disable cookies through your browser settings.</li>
        </ul>

        <h2>7. Third-Party Links</h2>
        <p>Our website may contain links to external sites. Growth Labs is not responsible for the privacy practices of these third-party sites. We encourage you to review their privacy policies before providing any personal information.</p>

        <h2>8. Children's Privacy</h2>
        <p>Our services are not directed at children under 13, and we do not knowingly collect information from them. If we discover that we have collected personal information from a child, we will promptly delete it.</p>

        <h2>9. Updates to this Policy</h2>
        <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any updates will be posted on this page with a revised effective date.</p>

        <h2>10. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or our data practices, please contact us: </p>
        <p>Growth Labs</p>
        <p>Email: <strong>mandy@growthlabadvertising.com</strong></p>
      </div>

      <p>By using our site and services, you agree to this Privacy Policy. If you do not agree, please discontinue use of our website.</p>

      <div className="back-to-home">
        <Link to="/">
          <button className="home-button">Back To Home</button>
        </Link>
      </div>
    </div>
    </section>
  );
};

export default PrivacyPolicy;